import React from 'react'
import { Row, Typography, Flex, Button } from 'antd'
import { NavLink } from 'react-router-dom'

const CalculatorFooter = ({ isSubscribed, isFree, result = null, driverObj = null, numberOfCalcs, isFreeTrial }) => {
    return (
        <>
            {
                isSubscribed === false ? (
                    <>
                        {!isFree && (
                            <>
                                <Row justify={'end'} style={{ marginTop: "1%" }}>
                                    <Typography.Text type='secondary' style={{ fontSize: "20px" }}>
                                        {isFreeTrial ? <i>Free Trial</i> : <i>Remaining Calculations: <strong style={{ color: "black" }}>{numberOfCalcs}</strong></i>}
                                    </Typography.Text>
                                </Row>
                                {numberOfCalcs < 6 && !isFreeTrial ? (
                                    <Row justify={'end'} style={{ marginTop: "1%" }}><Typography.Text type='secondary' style={{ fontSize: "15px" }}>Running low on calculations? Get more calculations <NavLink to={`/home?defKey=${"4"}&handleClick=${"billing"}`}>here!</NavLink></Typography.Text></Row>
                                ) : null}
                            </>
                        )}

                    </>
                ) : (
                    <Row justify={'end'} style={{ marginTop: "1%" }}>
                        <Typography.Text type='secondary' style={{ fontSize: "20px" }}><i>Unlimited Calculations</i></Typography.Text>
                    </Row>
                )
            }

            {(result && !isFree) && (
                <Flex justify='right'>
                    <Button
                        type='text'
                        onClick={() => {
                            driverObj.drive()
                        }}
                    >
                        <Typography.Text italic>Do you want to save this laser?</Typography.Text>
                    </Button>
                </Flex>
            )}
        </>
    )
}

export default CalculatorFooter
